module.exports = __webpack_public_path__ + "static/media/financehead2.9ac05973.jpg";